exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n  text-decoration: none;\n  color: #428bca;\n  border-bottom: dashed 1px #428bca;\n  cursor: pointer;\n  line-height: 1.5rem;\n  margin-right: 5px;\n  margin-left: 5px; }\n\ninput, select {\n  width: auto;\n  display: inline; }\n\n.editInvalid {\n  color: #a94442;\n  margin-bottom: 0; }\n\n.error {\n  border-color: #a94442; }\n\n.hidden {\n  display: none; }\n", ""]);

// exports
